import deviceKitNameExtended from "./deviceKitNameExtended";

const deviceKitNameTypeExtended = {
  DEV_TYPE_UNKNOWN: "DEV_TYPE_UNKNOWN",
  DEV_TYPE_V24_CHARGER: deviceKitNameExtended.IQOS_24_CHARGER,
  DEV_TYPE_V24_HOLDER: deviceKitNameExtended.IQOS_24_HOLDER,
  DEV_TYPE_V24P_CHARGER: deviceKitNameExtended.IQOS_24P_CHARGER,
  DEV_TYPE_V24P_HOLDER: deviceKitNameExtended.IQOS_24P_HOLDER,
  DEV_TYPE_P1V30_CHARGER: deviceKitNameExtended.IQOS_3_CHARGER,
  DEV_TYPE_P1V30_HOLDER: deviceKitNameExtended.IQOS_3_HOLDER,
  DEV_TYPE_P1V30M: deviceKitNameExtended.IQOS_3_MULTI,
  DEV_TYPE_P1V31_CHARGER: deviceKitNameExtended.IQOS_3_DUO_CHARGER,
  DEV_TYPE_P1V31_HOLDER: deviceKitNameExtended.IQOS_3_DUO_HOLDER,
  DEV_TYPE_P4_M3_G1: deviceKitNameExtended.IQOS_VEEV,
  DEV_TYPE_P4_M3_G2: deviceKitNameExtended.IQOS_VEEV,
  DEV_TYPE_P1V40V_CHARGER: deviceKitNameExtended.IQOS_ILUMA_PRIME_CHARGER,
  DEV_TYPE_P1V40V_HOLDER_CONTROL: deviceKitNameExtended.IQOS_ILUMA_PRIME_HOLDER,
  DEV_TYPE_P1V40C_CHARGER: deviceKitNameExtended.IQOS_ILUMA_CHARGER,
  DEV_TYPE_P1V40C_HOLDER_CONTROL: deviceKitNameExtended.IQOS_ILUMA_HOLDER,
  DEV_TYPE_P1V40D_CONTROL: deviceKitNameExtended.IQOS_ILUMA_ONE,
  DEV_TYPE_P1V31M: deviceKitNameExtended.IQOS_ORIGINALS_ONE,
  DEV_TYPE_P1_ARIANE: deviceKitNameExtended.IQOS_ARIANE
};

export default deviceKitNameTypeExtended;
